import { render, staticRenderFns } from "./AdminAllSentencesPage.vue?vue&type=template&id=6740bd2b&lang=pug&"
import script from "./AdminAllSentencesPage.vue?vue&type=script&lang=js&"
export * from "./AdminAllSentencesPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminAllSentencesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports